import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/downloadapp/DownloadAppClient.tsx");
